/* eslint-disable @typescript-eslint/no-explicit-any */
import { useToast } from "@/hooks";
import { endpoints } from "../endpoints";
import { deleteResource, patchResource, postResource } from "../https";
import { AddCart, RemoveCartItem, UpdateCart } from "../types";
import { useMutation } from "@tanstack/react-query";
import { useGetCartCount, useGetCartItems } from "../queries";

export const addToCart = (payload: AddCart) => {
  return postResource({ pathUrl: `${endpoints.cart}/add`, payload });
};

export const updateCartItem = (payload: UpdateCart) => {
  return patchResource({ pathUrl: `${endpoints.cart}/update/${payload.itemId}`, payload });
};

export const removeCartItem = (payload: RemoveCartItem) => {
  return deleteResource({ pathUrl: `${endpoints.cart}/remove`, payload });
};

export const clearCart = () => {
  return deleteResource({ pathUrl: `${endpoints.cart}/clear` });
};

export const useAddToCart = () => {
  const { toast } = useToast();
  const {refetch} = useGetCartCount()
  const {refetch: refetchCartItems} =  useGetCartItems()
  return useMutation({
    mutationFn: (payload: AddCart) => addToCart(payload),
    onSuccess: async (data) => {
      refetch()
      refetchCartItems()
      toast({
        title: "Success",
        description: `${data.message}`,
        variant: "default",
      });
    
    },
    onError: (error: any) => {
      toast({
        title: "Failed",
        description: `${error.message}`,
        variant: "destructive",
      });
    },
  });
};

export const useUpdateCartItem = () => {
  const { toast } = useToast();
  const {refetch} = useGetCartCount()
  const {refetch: refetchCartItems} =  useGetCartItems()
  return useMutation({
    mutationFn: (payload: UpdateCart) => updateCartItem(payload),
    onSuccess: async (data) => {
      refetch()
      refetchCartItems()
      toast({
        title: "Success",
        description: `${data.message}`,
      });
    },
    onError: (error: any) => {
      toast({
        title: "Failed",
        description: `${error.message}`,
        variant: "destructive",
      });
    },
  });
};

export const useRemoveCartItem = () => {
  const { toast } = useToast();
  const {refetch} = useGetCartCount()
  const {refetch: refetchCartItems} =  useGetCartItems()

  return useMutation({
    mutationFn: (payload: RemoveCartItem) => removeCartItem(payload),
    onSuccess: async (data) => {
      refetch()
      refetchCartItems()
      toast({
        title: "Success",
        description: `${data.message}`,
     
      });
     
    },
    onError: (error: any) => {
      toast({
        title: "Failed",
        description: `${error.message}`,
        variant: "destructive",
      });
    },
  });
};

export const useClearCart = () => {
  const { toast } = useToast();
  const {refetch} = useGetCartCount()
  const {refetch: refetchCartItems} =  useGetCartItems()

  return useMutation({
    mutationFn: () => clearCart(),
    onSuccess: async (data) => {
      refetch()
      refetchCartItems()
      toast({
        title: "Success",
        description: `${data.message}`,
      });
    
    },
    onError: (error: any) => {
      toast({
        title: "Failed",
        description: `${error.message}`,
        variant: "destructive",
      });
    },
  });
};